import React, { Component } from 'react';
import { string, bool } from 'prop-types';
import classnames from 'classnames/bind';
import { Consumer } from './FormField';

import Input from './Input';

import styles from './PrefixInput.css';

const cx = classnames.bind(styles);

export default class PrefixInput extends Component {
  static propTypes = {
    placeholder: string,
    type: string,
    locked: bool,
    customClasses: string
  };

  static defaultProps = {
    placeholder: 'CC',
    type: 'number'
  };

  state = { value: '' };

  handleChange = e => {
    const { value } = e.currentTarget;

    // HTML's input of number type doesn't accept a maxlength attribute
    if (value.length <= 3) {
      this.setState({ value });
    }
  }

  render() {
    const { placeholder, locked, type, customClasses } = this.props;
    const { value } = this.state;
    const wrapperClasses = cx(
      styles.prefixInputField,
      {
        isFilled: value.length,
        locked
      }
    );
    // TODO: Make the lable a part of this component
    return (
      <div className={wrapperClasses}>
        <Consumer>
          {sharedProps =>
            locked
              ? <span className={styles.locked}>{placeholder}</span>
              : <Input
                  sharedProps={sharedProps}
                  customClasses={`${styles.prefixInput} ${customClasses}`}
                  placeholder={placeholder}
                  readOnly={locked}
                  onChange={this.handleChange}
                  max={999}
                  value={value}
                  type={type}
                  min={1}
                />
          }
        </Consumer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/PrefixInput.js